export default "__VITE_ASSET__Cw6VC5yr__"